import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@growhero/brand/fonts.css';
// Tenant-chosen serif for public form pages only (not a brand font; no download unless used).
import '@growhero/brand/fonts-serif.css';
import './styles/index.css';
import './i18n';
import { App } from './app/App';
import { firebaseAuthAdapter } from './lib/firebase';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App authAdapter={firebaseAuthAdapter} />
  </StrictMode>,
);
